import React from 'react'
import { Col } from 'react-bootstrap'
import leadership from 'src/images/Leadership.png'
import { observer } from 'mobx-react'
import { productState } from 'src/views/components/BaseProductComponent/ProductState'
import { productStatusDeps } from 'src/views/components/ProductComponents/V2ProductQuantityAndButtons/ProductStatusDeps'
import { i18nTranslate } from 'src/utils'
@observer
class ProductLeaderPreviewMessages extends React.Component {
  render() {
    const {
      product = {},
      isExclusive = '',
      productCount = 1,
    } = this.props || {}

    const { qualificationMessage, exclusiveTitle } =
      productState.getQualificationMessage({
        productId: this.props?.product?.productId,
        isExclusive,
      })
    const { messageToDisplay } =
      productStatusDeps.getV2ProductLevelInventoryStatus(product, productCount)

    const purchaseLimitMsg =
      messageToDisplay ===
      i18nTranslate(
        'pdp.userEligible',
        'You have reached your purchase limit for this product.',
        {
          nameSpace: 'ssr-resource',
        }
      )
        ? messageToDisplay
        : ''

    return (
      <>
        {qualificationMessage && (
          <Col className="exclusive_messages">
            <div className="leader_preview d-flex align-items-center">
              <div className="leader_preview_icon">
                <img src={leadership} alt="" />
              </div>
              <div>
                <h6> {exclusiveTitle}</h6>
                <p className="p-0">{qualificationMessage}</p>
                {purchaseLimitMsg && <p className="p-0">{purchaseLimitMsg}</p>}
              </div>
            </div>
          </Col>
        )}
      </>
    )
  }
}
export default ProductLeaderPreviewMessages
export { ProductLeaderPreviewMessages }
